import { useContext, useEffect, useState } from "react";
import styles from "./styles/ProductsCard.module.css";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import bgimage1 from "./styles/card-bg-1.svg";
import bgimage2 from "./styles/card-bg-2.svg";
import bgimage3 from "./styles/card-bg-3.svg";
import bgimage4 from "./styles/card-bg-4.svg";
import useWindowDimensions from "../Footer/footer";
import {
  combinedDiscountPercent,
  isPromoBoosted,
  discountedPriceCents,
  discountedPerYearCents,
  listPriceCents,
  formatAmount,
} from "../../Utils/planDiscount";
export default function ProductCard({
  data,
  OnClick,
  selected,
  currency,
  order,
  index,
  isSubscriptionPage = false,
  isSubs,
  disableAllCards = false,
  /*
    The customer's promo code, when they signed up with one. Defaults to
    nothing, so every existing caller keeps today's behaviour.
  */
  coupon = null,
}) {
  const { width } = useWindowDimensions();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Payment.ProductCard
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Payment.ProductCard);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const cardDiscount = combinedDiscountPercent(data, currency, coupon);
  const promoBoosted = isPromoBoosted(data, currency, coupon);
  /*
    Only computed when a promo actually touches this card. Left null otherwise
    so every price below falls through to the original expression and an
    untouched card is rendered by exactly the code that always rendered it.
  */
  const payableCents = promoBoosted ? discountedPriceCents(data, currency, coupon) : null;
  const perYearCents = promoBoosted ? discountedPerYearCents(data, currency, coupon) : null;
  /*
    The struck-through "instead of" figure, per period.

    Normally the cost of paying monthly for the same stretch, which is what
    this line has always shown. The monthly and lifetime plans have no such
    baseline -- so today they show no line at all -- but once a promo lowers
    their price there has to be something to compare it against, and their own
    undiscounted price is that something. Without this the card would read
    "17.91/month, save 10%" with nothing saying 10% off what.
  */
  const strikeCents = (() => {
    const opts = data?.default_price?.currency_options?.[currency];
    const years = Number(data?.metadata?.years);
    const perPeriod = (cents) =>
      Number.isFinite(years) && years >= 1 ? cents / years : cents;

    const baseline = Number(opts?.total_price_no_discount);
    if (Number.isFinite(baseline) && baseline > 0) return perPeriod(baseline);

    if (!promoBoosted) return null;
    /*
      The plan's own undiscounted headline price -- NOT unit_amount/years,
      which would turn the lifetime plan's 3997 into 40.
    */
    return listPriceCents(data, currency);
  })();

  let bgColor = null;
  let bgImage = null;
  let bgImageHeight = 80;

  if (index === 1) {
    bgColor = "#0091EA1A";
    bgImage = bgimage1;
    bgImageHeight = isSubscriptionPage && width > 1305 ? 110 : 115;
  } else if (index === 2) {
    bgColor = "#CEECFF80";
    bgImage = bgimage2;
    bgImageHeight = isSubscriptionPage && width > 1305 ? 132 : 130;
  } else if (index === 3) {
    bgColor = "#D5E0FA80";
    bgImage = bgimage3;
    bgImageHeight = isSubscriptionPage && width > 1305 ? 120 : 123;
  } else if (index === 4) {
    bgColor = "#E6DEFF66";
    bgImage = bgimage4;
    bgImageHeight = isSubscriptionPage && width > 1305 ? 133 : 132;
  }

  return (
    <>
      {data.default_price.currency_options[currency] && (
        <div
          key={data.id}
          className={selected ? styles.main_selected : styles.main}
          style={{
            order: order,
            backgroundColor: bgColor,
            borderColor: isSubs ? "#419F23" : "",
          }}
        >
          <div
            className={styles.plan_container}
            style={
              isSubscriptionPage && width > 1305
                ? {
                    minWidth: "unset",
                  }
                : {}
            }
          >
            {/* discount section */}
            {/* {data.discount && (
              <div className={styles.discount}>
                {content.productCardText1} {parseInt(data.discount)}%
              </div>
            )} */}
            <div className={styles.plan_title}>
              {(
                data.metadata[`${websiteCurrentLang?.label}_name`] || data?.name
              )?.toUpperCase()}
            </div>
            {strikeCents !== null ? (
              <div
                className={styles.old_price}
                style={{
                  height: "20px",
                }}
              >
                {dublicatedcontent?.instead_of} <span></span>
                <span>
                  {dublicatedcontent?.price_format
                    ?.replace(
                      "currency_",
                      data.default_price.currency_options[currency]?.symbol
                    )
                    ?.replace("amount_", formatAmount(strikeCents))}
                </span>
                <span>
                  {Number(data?.metadata?.years) < 1
                    ? dublicatedcontent?.month
                    : dublicatedcontent.dublicatedText232}
                </span>
              </div>
            ) : (
              <div
                style={{
                  height: "20px",
                }}
              ></div>
            )}
            <div
              className={styles.plan_price}
              style={
                isSubscriptionPage && width > 1305
                  ? {
                      fontSize: "32px",
                    }
                  : {}
              }
            >
              <>
                {`${dublicatedcontent?.price_format
                  ?.replace(
                    "currency_",
                    data.default_price.currency_options[currency]?.symbol
                  )
                  ?.replace(
                    "amount_",
                    /*
                      The price with the promo taken off, so it agrees with the
                      badge below. Falls back to the original figures when
                      there is no code, which is every card today.
                    */
                    formatAmount(perYearCents) ??
                      (data.default_price.currency_options[currency]
                        ?.yearly_price
                        ? parseInt(
                            data.default_price.currency_options[currency]
                              ?.yearly_price
                          ) / 100
                        : parseInt(
                            data.default_price.currency_options[currency]
                              ?.unit_amount_decimal
                          ) / 100)
                  )
                  .replace(" ", "")}`}
              </>
              <span className={styles.plan_price_sub}>
                {" "}
                {Number(data?.metadata?.years) < 1
                  ? dublicatedcontent?.dublicatedText_slash_mois
                  : Number(data?.metadata?.years) > 70
                  ? undefined
                  : dublicatedcontent.dublicatedText232}
              </span>
            </div>

            <div className={styles.bottom_price}>
              <div className={styles.price}>
                {data.name === "Monthly"
                  ? dublicatedcontent?.billed_monthly
                  : dublicatedcontent?.billed_once}
                <span> </span>
                <span>
                  {dublicatedcontent?.price_format
                    ?.replace(
                      "currency_",
                      data.default_price.currency_options[currency]?.symbol
                    )
                    ?.replace(
                      "amount_",
                      /* What is actually charged, promo included. */
                      formatAmount(payableCents) ??
                        parseInt(
                          data.default_price.currency_options[currency]
                            ?.unit_amount_decimal
                        ) / 100
                    )}{" "}
                </span>
              </div>
              {/*
                The plan's own saving, or that saving with the customer's promo
                code folded in -- see Utils/planDiscount. With no code this is
                the same number `data.discount` always held, so a card without a
                promo renders exactly as before.
              */}
              {cardDiscount !== null && (
                <div
                  className={styles.discount}
                  title={
                    promoBoosted && coupon?.code
                      ? `${content.productCardText1} ${parseInt(cardDiscount)}% — ${coupon.code}`
                      : undefined
                  }
                >
                  {content.productCardText1} {parseInt(cardDiscount)}%
                </div>
              )}
            </div>

            <div
              onClick={OnClick}
              className={styles.subscribe}
              disabled={isSubs || disableAllCards}
            >
              {isSubs
                ? dublicatedcontent.current_plan
                : dublicatedcontent?.subscribe}
            </div>
          </div>
          <div
            className={styles.bg_image}
            style={{
              height: bgImageHeight + "px",
            }}
          >
            <img src={bgImage} alt="bg_image" />
          </div>
        </div>
      )}
    </>
  );
}
